import React, { useState, useEffect, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  Typography,
} from '@mui/material';

import ManageReportDataApi from '../../Api/ApiManageReportData';
import appdata from '../../Services/appdata';
import Fees_Small from '../../Assets/image/Resized_Small/Fees_Small.png';
import Fees_Large from '../../Assets/image/Resized_Large/Fees_Large.png';
import Expenses_Small from '../../Assets/image/Resized_Small/Expenses_Small.png';
import Expenses_Large from '../../Assets/image/Resized_Large/Expenses_Large.png';
import FinancialYTD_Small from '../../Assets/image/Resized_Small/FinancialYTD_Small.png';
import FinancialYTD_Large from '../../Assets/image/Resized_Large/FinancialYTD_Large.png';
import YearlyFinancialPerformance_Small from '../../Assets/image/Resized_Small/YearlyFinancialPerformance_Small.png';
import YearlyFinancialPerformance_Large from '../../Assets/image/Resized_Large/YearlyFinancialPerformance_Large.png';
import Balancesheet_Small from '../../Assets/image/Resized_Small/BalanceSheet.png';
import Balancesheet_Large from '../../Assets/image/Resized_Large/BalanceSheet.png';
import Cashflow_Small from '../../Assets/image/Resized_Small/Cashflow_Small.png';
import Cashflow_Large from '../../Assets/image/Resized_Large/Cashflow_Large.png';
import Debtors_Small from '../../Assets/image/Resized_Small/Debtors_Small.png';
import Debtors_Large from '../../Assets/image/Resized_Large/Debtors_Large.png';
import ProjectPerformance_Small from '../../Assets/image/Resized_Small/Project Performance.png';
import ProjectPerformance_Large from '../../Assets/image/Resized_Large/Project Performance.png';
import Opportunities_Small from '../../Assets/image/Resized_Small/Opportunities_Small.png';
import Opportunities_Large from '../../Assets/image/Resized_Large/Opportunities_Large.png';
import WorkGenerated_Small from '../../Assets/image/Resized_Small/WorkGenerated_Small.png';
import WorkGenerated_Large from '../../Assets/image/Resized_Large/WorkGenerated_Large.png';
import WorkInHand_Small from '../../Assets/image/Resized_Small/WorkInHand.png';
import WorkInHand_Large from '../../Assets/image/Resized_Large/WorkInHand.png';
import FeeProjection_Small from '../../Assets/image/Resized_Small/FeeProjection_Small.png';
import FeeProjection_Large from '../../Assets/image/Resized_Large/FeeProjection_Large.png';
import ProjectedFinancial_Small from '../../Assets/image/Resized_Small/ProjectedFinancial_Small.png';
import ProjectedFinancial_Large from '../../Assets/image/Resized_Large/ProjectedFinancial_Large.png';
import ProjectedCashflow_Small from '../../Assets/image/Resized_Small/ProjectedCashflow_Small.png';
import ProjectedCashflow_Large from '../../Assets/image/Resized_Large/ProjectedCashflow_Large.png';
import People_Small from '../../Assets/image/Resized_Small/People_Small.png';
import People_Large from '../../Assets/image/Resized_Large/People_Large.png';
import KPI_Small from '../../Assets/image/Resized_Small/KPI_Small.png';
import KPI_Large from '../../Assets/image/Resized_Large/KPI_Large.png';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);
  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: 8,
  margin: `0 0 8px 0`,
  opacity: isDragging ? 0.5 : 1,
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'white',
  float: 'left',
  height: '84vh',
  width: '100%',
});

const report_pages = [
  { id: 2, title: 'Fees', bubble: false, small_image: Fees_Small, large_image: Fees_Large, descrption: '' },
  { id: 3, title: 'Expenses', bubble: false, small_image: Expenses_Small, large_image: Expenses_Large, descrption: '' },
  { id: 4, title: 'Financial Performance YTD', bubble: false, small_image: FinancialYTD_Small, large_image: FinancialYTD_Large, descrption: '' },
  { id: 5, title: 'Yearly Financial Performance', bubble: false, small_image: YearlyFinancialPerformance_Small, large_image: YearlyFinancialPerformance_Large, descrption: '' },
  { id: 6, title: 'Balance Sheet', bubble: false, small_image: Balancesheet_Small, large_image: Balancesheet_Large, descrption: '' },
  { id: 7, title: 'Cash Flow', bubble: false, small_image: Cashflow_Small, large_image: Cashflow_Large, descrption: '' },
  { id: 8, title: 'Debtors', bubble: false, small_image: Debtors_Small, large_image: Debtors_Large, descrption: '' },
  { id: 9, title: 'Project Performance', bubble: false, small_image: ProjectPerformance_Small, large_image: ProjectPerformance_Large, descrption: '' },
  { id: 10, title: 'Work In Hand', bubble: false, small_image: WorkInHand_Small, large_image: WorkInHand_Large, descrption: '' },
  { id: 11, title: 'Opportunities', bubble: false, small_image: Opportunities_Small, large_image: Opportunities_Large, descrption: '' },
  { id: 12, title: 'Work Generated', bubble: false, small_image: WorkGenerated_Small, large_image: WorkGenerated_Large, descrption: '' },
  { id: 13, title: 'Fee Projection', bubble: false, small_image: FeeProjection_Small, large_image: FeeProjection_Large, descrption: '' },
  { id: 14, title: 'Projected Financial Performance', bubble: false, small_image: ProjectedFinancial_Small, large_image: ProjectedFinancial_Large, descrption: '' },
  { id: 15, title: 'Projected Cash Flow', bubble: false, small_image: ProjectedCashflow_Small, large_image: ProjectedCashflow_Large, descrption: '' },
  { id: 16, title: 'People', bubble: false, small_image: People_Small, large_image: People_Large, descrption: '' },
  { id: 17, title: 'Business Performance', bubble: false, small_image: KPI_Small, large_image: KPI_Large, descrption: '' },
];

const ReportPageSelectionTable = (props) => {
  const [reportPages, setReportPages] = useState([]);
  const [droppable1, setDroppable1] = useState([]);
  const [droppable2, setDroppable2] = useState([]);
  const [droppable3, setDroppable3] = useState([]);
  const [droppable4, setDroppable4] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(-1);
  const [selectedReport, setSelectedReport] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [bubbleEnabled, setBubbleEnabled] = useState(false);

  // Helper to get the correct droppable list
  const getList = useCallback((id) => {
    switch (id) {
      case 'droppable1': return droppable1;
      case 'droppable2': return droppable2;
      case 'droppable3': return droppable3;
      case 'droppable4': return droppable4;
      default: return [];
    }
  }, [droppable1, droppable2, droppable3, droppable4]);

  // Prepare data from props.rows
  const prepareData = useCallback(() => {
    const { rows } = props;
    let _reportPages = [];
    let _droppable1 = [];
    let _droppable2 = [];
    let _droppable3 = [];
    let _droppable4 = [];
    
    if (rows.length === 0) {
      report_pages.forEach((report, index) => {
        if (index % 4 === 0) _droppable1.push(report);
        else if (index % 4 === 1) _droppable2.push(report);
        else if (index % 4 === 2) _droppable3.push(report);
        else if (index % 4 === 3) _droppable4.push(report);
      });
      setReportPages(_reportPages);
      setDroppable1(_droppable1);
      setDroppable2(_droppable2);
      setDroppable3(_droppable3);
      setDroppable4(_droppable4);
    } else {
      rows.forEach((report, index) => {
        if (report.active) _reportPages.push(report.id);
        if (index % 4 === 0) _droppable1.push(report);
        else if (index % 4 === 1) _droppable2.push(report);
        else if (index % 4 === 2) _droppable3.push(report);
        else if (index % 4 === 3) _droppable4.push(report);
      });
      setReportPages(_reportPages);
      setDroppable1(_droppable1);
      setDroppable2(_droppable2);
      setDroppable3(_droppable3);
      setDroppable4(_droppable4);
    }
  }, [props]);

  // Fetch companies on mount
  useEffect(() => {
    ManageReportDataApi.getCompanies()
      .then((res) => {
        if (res.status === 200) {
          const company_org_id = appdata.getItem('company_org_id');
          let selectedCompany = company_org_id
            ? company_org_id
            : res.data && res.data.length === 1
            ? res.data[0].id
            : -1;
          setCompanies(res.data);
          setSelectedCompany(selectedCompany);
        } else toast.error(res.message);
      })
      .catch((error) => toast.error(error.message));
    // eslint-disable-next-line
  }, []);

  // Prepare data when props.rows changes
  useEffect(() => {
    prepareData();
  }, [props.rows, prepareData]);

  // Drag and drop handler
  const onDragEnd = (result) => {
    const { source, destination } = result;
    let update_data = [];
    if (!destination) return;
    let newDroppable1 = droppable1;
    let newDroppable2 = droppable2;
    let newDroppable3 = droppable3;
    let newDroppable4 = droppable4;
    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        getList(source.droppableId),
        source.index,
        destination.index === -1 ? 0 : destination.index,
      );
      if (source.droppableId === 'droppable1') {
        newDroppable1 = items;
        for (let i = 0; i < newDroppable1.length; i++) {
          update_data.push(newDroppable1[i]);
          update_data.push(newDroppable2[i]);
          update_data.push(newDroppable3[i]);
          update_data.push(newDroppable4[i]);
        }
      }
      if (source.droppableId === 'droppable2') {
        newDroppable2 = items;
        for (let i = 0; i < newDroppable1.length; i++) {
          update_data.push(newDroppable1[i]);
          update_data.push(newDroppable2[i]);
          update_data.push(newDroppable3[i]);
          update_data.push(newDroppable4[i]);
        }
      }
      if (source.droppableId === 'droppable3') {
        newDroppable3 = items;
        for (let i = 0; i < newDroppable1.length; i++) {
          update_data.push(newDroppable1[i]);
          update_data.push(newDroppable2[i]);
          update_data.push(newDroppable3[i]);
          update_data.push(newDroppable4[i]);
        }
      }
      if (source.droppableId === 'droppable4') {
        newDroppable4 = items;
        for (let i = 0; i < newDroppable1.length; i++) {
          update_data.push(newDroppable1[i]);
          update_data.push(newDroppable2[i]);
          update_data.push(newDroppable3[i]);
          update_data.push(newDroppable4[i]);
        }
      }
      setDroppable1(newDroppable1);
      setDroppable2(newDroppable2);
      setDroppable3(newDroppable3);
      setDroppable4(newDroppable4);
    } else {
      let result = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination,
      );
      let keys = [];
      Object.keys(result).map((list) => keys.push(list));
      if (keys.indexOf('droppable1') === -1) result.droppable1 = droppable1;
      if (keys.indexOf('droppable2') === -1) result.droppable2 = droppable2;
      if (keys.indexOf('droppable3') === -1) result.droppable3 = droppable3;
      if (keys.indexOf('droppable4') === -1) result.droppable4 = droppable4;
      if (result.droppable1.length === 5) {
        if (result.droppable2.length === 3) result.droppable2.push(result.droppable1[result.droppable1.length - 1]);
        else if (result.droppable3.length === 3) result.droppable3.push(result.droppable1[result.droppable1.length - 1]);
        else if (result.droppable4.length === 3) result.droppable4.push(result.droppable1[result.droppable1.length - 1]);
        result.droppable1.splice(-1, 1);
      }
      if (result.droppable2.length === 5) {
        if (result.droppable1.length === 3) result.droppable1.push(result.droppable2[result.droppable2.length - 1]);
        else if (result.droppable3.length === 3) result.droppable3.push(result.droppable2[result.droppable2.length - 1]);
        else if (result.droppable4.length === 3) result.droppable4.push(result.droppable2[result.droppable2.length - 1]);
        result.droppable2.splice(-1, 1);
      }
      if (result.droppable3.length === 5) {
        if (result.droppable1.length === 3) result.droppable1.push(result.droppable3[result.droppable3.length - 1]);
        else if (result.droppable2.length === 3) result.droppable2.push(result.droppable3[result.droppable3.length - 1]);
        else if (result.droppable4.length === 3) result.droppable4.push(result.droppable3[result.droppable3.length - 1]);
        result.droppable3.splice(-1, 1);
      }
      if (result.droppable4.length === 5) {
        if (result.droppable1.length === 3) result.droppable1.push(result.droppable4[result.droppable4.length - 1]);
        else if (result.droppable2.length === 3) result.droppable2.push(result.droppable4[result.droppable4.length - 1]);
        else if (result.droppable3.length === 3) result.droppable3.push(result.droppable4[result.droppable4.length - 1]);
        result.droppable4.splice(-1, 1);
      }
      for (let i = 0; i < result.droppable1.length; i++) {
        if (result.droppable1[i]) update_data.push(result.droppable1[i]);
        if (result.droppable2[i]) update_data.push(result.droppable2[i]);
        if (result.droppable3[i]) update_data.push(result.droppable3[i]);
        if (result.droppable4[i]) update_data.push(result.droppable4[i]);
      }
      setDroppable1(result.droppable1);
      setDroppable2(result.droppable2);
      setDroppable3(result.droppable3);
      setDroppable4(result.droppable4);
    }
    update_data.forEach((data) => {
      if (reportPages.indexOf(data.id) !== -1) {
        data.active = true;
      } else {
        data.active = false;
      }
    });
    ManageReportDataApi.updateTemplate(props.name, JSON.stringify(update_data))
      .then((res) => {
        if (res.status === 500) toast.error(res.message);
      })
      .catch((error) => toast.error(error.message));
  };

  // Checkbox handler
  const handleReportCheck = async (value) => {
    let update_data = [];
    const currentIndex = reportPages.indexOf(value);
    const newChecked = [...reportPages];
    if (currentIndex === -1) newChecked.push(value);
    else newChecked.splice(currentIndex, 1);
    for (let i = 0; i < droppable1.length; i++) {
      update_data.push(droppable1[i]);
      update_data.push(droppable2[i]);
      update_data.push(droppable3[i]);
      update_data.push(droppable4[i]);
    }
    setReportPages(newChecked);
    update_data.forEach((data) => {
      if (newChecked.indexOf(data.id) !== -1) {
        data.active = true;
      } else {
        data.active = false;
      }
    });
    await ManageReportDataApi.updateTemplate(
      props.name,
      JSON.stringify(update_data),
    );
  };

  const handleReportSwitchBubble = async (value) => {
    let update_data = [];
    if (droppable1.find((item) => item.id === value)) {
      let newDroppable1 = [...droppable1];
      newDroppable1.map((item) => {
        if (item.id === value) {
          item.bubble = !item.bubble;
        }
        return item;
      });
      setDroppable1(newDroppable1);
    } else if (droppable2.find((item) => item.id === value)) {
      let newDroppable2 = [...droppable2];
      newDroppable2.map((item) => {
        if (item.id === value) {
          item.bubble = !item.bubble;
        }
        return item;
      });
      setDroppable2(newDroppable2);
    } else if (droppable3.find((item) => item.id === value)) {
      let newDroppable3 = [...droppable3];
      newDroppable3.map((item) => {
        if (item.id === value) {
          item.bubble = !item.bubble;
        }
        return item;
      });
      setDroppable3(newDroppable3);
    } else if (droppable4.find((item) => item.id === value)) {
      let newDroppable4 = [...droppable4];
      newDroppable4.map((item) => {
        if (item.id === value) {
          item.bubble = !item.bubble;
        }
        return item;
      });
      setDroppable4(newDroppable4);
    }
    
    for (let i = 0; i < droppable1.length; i++) {
      update_data.push(droppable1[i]);
      update_data.push(droppable2[i]);
      update_data.push(droppable3[i]);
      update_data.push(droppable4[i]);
    }
    
    await ManageReportDataApi.updateTemplate(props.name, JSON.stringify(update_data))
      .then((res) => {
        if (res.status === 500) toast.error(res.message);
      })
      .catch((error) => toast.error(error.message));
  };

  // Company select handler
  const handleSelectCompany = async (ev) => {
    appdata.setItem('company_org_id', ev.target.value);
    setSelectedCompany(ev.target.value);
    await props.getTemplateData('Report Page Selection', ev.target.value);
  };

  // Modal open/close handlers
  const handleOpenModal = (item) => {
    setSelectedReport(item);
    setBubbleEnabled(item.bubble || false);
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  
  return (
    <>
      <Grid size={12}>
        <label style={{ marginLeft: 8, marginTop: 12 }}>Company : </label>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <Select value={selectedCompany} onChange={handleSelectCompany}>
            <MenuItem value={-1} disabled>
              {' '}
            </MenuItem>
            {companies &&
              companies.map(
                (cur) =>
                  cur.IsActive && (
                    <MenuItem key={cur.id} value={cur.id}>
                      {cur.CompanyName}
                    </MenuItem>
                  ),
              )}
          </Select>
        </FormControl>
      </Grid>
      <DragDropContext onDragEnd={onDragEnd}>
        <Grid
          container
          spacing={1}
          style={{ height: '85vh', width: '101%', overflowY: 'auto' }}
        >
          {[droppable1, droppable2, droppable3, droppable4].map((droppable, idx) => (
            <Grid size={3} key={idx}>
              <Droppable droppableId={`droppable${idx + 1}`}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {droppable.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={item.id.toString()}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style,
                            )}
                          >
                            <Card>
                              <CardHeader
                                action={
                                  <IconButton style={{ padding: 0 }}>
                                    <Checkbox
                                      checked={reportPages.indexOf(item.id) !== -1}
                                      onChange={() => handleReportCheck(item.id)}
                                      inputProps={{
                                        'aria-label': 'primary checkbox',
                                      }}
                                      color="success"
                                    />
                                  </IconButton>
                                }
                                title={item.title}
                                sx={{
                                  padding: '8px',
                                  '& .MuiCardHeader-content': {
                                    width: '84%',
                                    '& .MuiTypography-displayBlock': {
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    },
                                  },
                                }}
                              />
                              <CardMedia
                                component="img"
                                onDoubleClick={() => handleOpenModal(item)}
                                image={item.small_image}
                                title={item.title}
                              />
                              <CardActions sx={{ justifyContent: 'flex-end' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography variant="body2" style={{ marginRight: 8 }}>
                                    AI bubble:
                                  </Typography>
                                  <Switch
                                    checked={item.bubble}
                                    onChange={() => handleReportSwitchBubble(item.id)}
                                    color="primary"
                                  />
                                </div>
                              </CardActions>
                            </Card>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Grid>
          ))}
        </Grid>
      </DragDropContext>
      
      <Dialog maxWidth="lg" onClose={handleModalClose} open={modalOpen}>
        <DialogTitle onClose={handleModalClose}>
          {selectedReport.title}
        </DialogTitle>
        <DialogContent dividers>
          <Card style={{ boxShadow: 'none' }}>
            <Grid container spacing={1}>
              <Grid size={8}>
                <CardMedia
                  component="img"
                  image={selectedReport.large_image}
                  title={selectedReport.title}
                />
              </Grid>
              <Grid size={4}>
                <CardContent>
                  <Typography variant="subtitle1" color="textSecondary">
                    This impressive paella is a perfect party dish and a fun
                    meal to cook together with your guests. Add 1 cup of
                    frozen peas along with the mussels, if you like.
                  </Typography>
                </CardContent>
              </Grid>
            </Grid>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleModalClose}
            style={{ color: '#1976d2' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReportPageSelectionTable;
